import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsCategoryLandingPageHeader {
    export const ID = 'cms-category-landing-page-header';

    export interface IBlockDataContent {
        title: string;
        description?: string;
        variant?: 'default' | 'light';
        links?: IQuickLink[];
        showBreadcrumb?: boolean;
    }

    export interface IQuickLink {
        text: string;
        url: string;
        image?: string;
    }
}
@ICmsComponent<CmsCategoryLandingPageHeaderComponent>({
    id: NCmsCategoryLandingPageHeader.ID,
    name: 'Category landing page header',
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            options: [
                {
                    key: 'default',
                    title: 'Dark'
                },
                {
                    key: 'light',
                    title: 'Light'
                }
            ],
            default: 'default'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true,
            default: 'Category title'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'description',
            title: 'Description'
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'showBreadcrumb',
            title: 'Show breadcrumb',
            default: true
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'links',
            title: 'Links',
            itemName: 'Link',
            itemNameField: 'title',
            defaultSize: 0,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Url',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                }
            ]
        }
    ]
})
@Component({
    selector: 'cms-category-landing-page-header',
    templateUrl: './cms-category-landing-page-header.html',
    styleUrls: ['cms-category-landing-page-header.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsCategoryLandingPageHeaderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    content?: NCmsCategoryLandingPageHeader.IBlockDataContent;
}
